(() => {
  function initSizeChart() {
    const dialog = document.querySelector("#GarudaSizeChart");

    if (!dialog) return;

    const triggers = document.querySelectorAll(
      "[data-size-chart-trigger]"
    );

    const closeButton = dialog.querySelector(
      "[data-size-chart-close]"
    );

    triggers.forEach((trigger) => {
      if (trigger.dataset.sizeChartInitialized) return;

      trigger.dataset.sizeChartInitialized = "true";

      trigger.addEventListener("click", () => {
        dialog.showModal();

        requestAnimationFrame(() => {
          dialog.classList.add("garuda-size-chart-is-open");
        });
      });
    });

    if (
      closeButton &&
      !closeButton.dataset.sizeChartInitialized
    ) {
      closeButton.dataset.sizeChartInitialized = "true";

      closeButton.addEventListener("click", () => {
        dialog.classList.remove("garuda-size-chart-is-open");

        setTimeout(() => {
          if (dialog.open) {
            dialog.close();
          }
        }, 220);
      });
    }

    if (!dialog.dataset.backdropInitialized) {
      dialog.dataset.backdropInitialized = "true";

      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) {
          dialog.classList.remove("garuda-size-chart-is-open");

          setTimeout(() => {
            if (dialog.open) {
              dialog.close();
            }
          }, 220);
        }
      });

      dialog.addEventListener("cancel", () => {
        dialog.classList.remove("garuda-size-chart-is-open");
      });

      dialog.addEventListener("close", () => {
        dialog.classList.remove("garuda-size-chart-is-open");
      });
    }
  }

  document.addEventListener(
    "DOMContentLoaded",
    initSizeChart
  );

  document.addEventListener(
    "shopify:section:load",
    initSizeChart
  );

  initSizeChart();
})();